/**
 * Checks whether all non-space characters in `query` appear in `text` in order
 * (subsequence match). Both strings are compared case-insensitively.
 *
 * @example
 * fuzzyMatch('Reverse - Hazards - Version', 'reversehaz') // true
 * fuzzyMatch('First Name', 'fn')                          // true
 * fuzzyMatch('First Name', 'first name')                  // true (spaces ignored)
 * fuzzyMatch('Status', 'uts')                             // false (order matters)
 * fuzzyMatch('Name', 'namez')                             // false (missing character)
 */
export function fuzzyMatch(text: string, query: string): boolean {
  const normalizedText = text.toLowerCase();
  const normalizedQuery = query.toLowerCase().trim();

  let textIndex = 0;
  for (let i = 0; i < normalizedQuery.length; i++) {
    if (normalizedQuery[i] === ' ') continue;
    textIndex = normalizedText.indexOf(normalizedQuery[i], textIndex);
    if (textIndex === -1) return false;
    textIndex++;
  }

  return true;
}
